<template lang="pug">
#app
  transition(name="slide-fade")
    router-view
</template>

<script>
import Services from "./utils/services";

export default {
  async created() {
    let token = await localStorage.getItem("token");
    if (!token) {
      this.$router.push("/login");
    } else {
      this.getPerfil();
      //this.$router.push("/");
    }
  },
  methods: {
    async getPerfil() {
      let perfil = await Services.get("/perfil");
      console.log("Perfil: ", perfil);
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,400&display=swap");

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  font-family: "Roboto", sans-serif;
}

#app {
  width: 100%;
  height: 100%;
  font-family: "Roboto", sans-serif;
  //background: #F5F5F5;

  .slide-fade-enter-active {
    transition: all 0.6s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.6s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    transform: translateX(15px);
    opacity: 0;
  }
}
</style>
